import { gql } from '@apollo/client';

const CHAT_WITH_TASK = gql`
  mutation ChatWithTask($taskUuid: ID!, $messages: [ChatMessageInput!]!) {
    chatWithTask(taskUuid: $taskUuid, messages: $messages) {
      success
      errors
      reply
    }
  }
`;

const ACCEPT_TASK_RECOMMENDATION = gql`
  mutation AcceptTaskRecommendation($taskUuid: ID!, $content: JSON!, $title: String) {
    acceptTaskRecommendation(taskUuid: $taskUuid, content: $content, title: $title) {
      success
      errors
    }
  }
`;

export { CHAT_WITH_TASK, ACCEPT_TASK_RECOMMENDATION };
